module.exports = __webpack_public_path__ + "img/card1.fbcf274f.png";